const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'advertisements',
        // showHead: false,
        // showIDs: true,
        // showTDVerticalTop: true,
        lazyloadStepSize: 10,
        isSortable: true,
        preventSortOfField: {
            location: true,
            skills: true,
            customerCompanyName: true,
        },
        // rowActionsInline: true,
        rowActionsProperties: {
            // colWidth: '105px',
            colWidth: '79px',
        },
        rowActions: {
            // edit: true,
            customs: [
                {
                    buttonType: 'edit',
                    mode: 'revoked',
                    // negative: true,
                    icon: 'fi fi-revoke',
                },
                {
                    buttonType: 'edit',
                    mode: 'waitlisted',
                    // positive: true,
                    icon: 'fi fi-waitlist'
                },
                {
                    buttonType: 'edit',
                    mode: 'applied',
                    // positive: true,
                    icon: 'fi fi-apply'
                },
                {
                    buttonType: 'edit',
                    mode: 'agreed',
                    // positive: true,
                    icon: 'fi fi-agree'
                },
            ]
        },

        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_projectTermJobStatus': true,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_employees_jobs': true,
            'resourceChanged.bo_prices': true,
            'resourceChanged.bo_jobs': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'timeRange',
                direction: 'asc'
            },{
                fieldCode: 'jobCode',
                direction: 'asc'
            },{
                fieldCode: 'status',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onResourceSanitized(){
            this.storeLoadedStatusIDs()

            this.closest('templates_core_controller_controller', controller => {
                controller.find('templates_crew_advertisements_summary', summary => {
                    if(summary.$.length){
                        summary.refresh()
                    }
                })

                controller.find('templates_crew_advertisements_stats', stats => {
                    stats.update((this.resourceData || {}).stats)
                })
            })
        },

        async edit(rowID, rowData, buttonMode){
            const baseActionKey = `edit_projectTermJobStatus`
            const nextStatus = buttonMode // read, agreed, revoked, applied, waitlisted
            const {
                projectTermJobID,
                status,
                statusOutDated,
            } = (rowData || {}).attributes || {}

            if(projectTermJobID && (nextStatus === 'applied' || nextStatus === 'waitlisted' || nextStatus === 'agreed' || nextStatus === 'revoked') && (status !== nextStatus || statusOutDated)){
                await this.performAction(
                    this.prepareAction(
                        baseActionKey,
                        undefined,
                        undefined,
                        {
                            source: {
                                submit: {
                                    data: {
                                        resourceParams: {
                                            projectTermJobID,
                                            status: nextStatus,
                                        }
                                    }
                                }
                            }
                        }
                    ),
                )
            }
            // TODO: else some message?

            return utils.promise.resolve()
        },

        sanitizeEntity: function(refEntity){
            refEntity.additionalClasses = []
            const attributes = refEntity.attributes || {}
            if(attributes.nextPositiveStatus){
                refEntity.additionalClasses.push(`nextPositiveStatus_${attributes.nextPositiveStatus}`)
            }
            if(attributes.allJobsInPast){
                refEntity.additionalClasses.push('allJobsInPast')
            }
            if(attributes.status === attributes.nextPositiveStatus){
                refEntity.additionalClasses.push(`finalPositiveStatusReached`)
            }

            if(attributes.status === 'revoked') {
                if(attributes.statusOutDated) {
                    refEntity.additionalClasses.push(`negativeStatusOutDated`)
                } else {
                    refEntity.additionalClasses.push(`negativeStatusReached`)
                }
            } else if(attributes.status) {
                if(attributes.statusOutDated) {
                    refEntity.additionalClasses.push(`positiveStatusOutDated`)
                } else {
                    refEntity.additionalClasses.push(`positiveStatusReached`)
                }
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const myEmployeeID  = (((((storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}).employeeID
            const myEmployeeAffected = (message.data.employeeID == myEmployeeID || (message.data.employeeIDs || {})[myEmployeeID])

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTermJobStatus' &&
                    key !== 'resourceChanged.bo_employees' &&
                    key !== 'resourceChanged.bo_employees_jobs' &&
                    key !== 'resourceChanged.bo_prices'
                ) ||
                (key === 'resourceChanged.bo_projectTermJobStatus' && myEmployeeAffected) ||
                (key === 'resourceChanged.bo_employees' && (myEmployeeAffected || message.data.primaryKeys[myEmployeeID])) ||
                (key === 'resourceChanged.bo_employees_jobs' && myEmployeeAffected) ||
                (key === 'resourceChanged.bo_prices' && myEmployeeAffected)
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    }
}